import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=56bbef28&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"
import style0 from "./signup.vue?vue&type=style&index=0&id=56bbef28&lang=scss"
import style1 from "./signup.vue?vue&type=style&index=1&id=56bbef28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbef28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bbef28')) {
      api.createRecord('56bbef28', component.options)
    } else {
      api.reload('56bbef28', component.options)
    }
    module.hot.accept("./signup.vue?vue&type=template&id=56bbef28&scoped=true", function () {
      api.rerender('56bbef28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/signup.vue"
export default component.exports